import {Component, OnInit} from '@angular/core';
import {MercadoriasClassificacaoService} from "./mercadorias-classificacao.service";
import {MercadoriasClassificacaoModel} from "./mercadorias-classificacao.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {TranslateService} from '@ngx-translate/core';
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-mercadorias-classificacao',
  templateUrl: './mercadorias-classificacao.component.html'
})
export class MercadoriasClassificacaoComponent extends Components implements OnInit {

  classificacoes: MercadoriasClassificacaoModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private mercadoriasClassificacaoService: MercadoriasClassificacaoService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'mercadorias'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.getPage(1);
    /*this.mercadoriasClassificacaoService.getPaginacao(1,this.itensPorPagina)
      .subscribe(data => {
        this.classificacoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.classificacoes);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });*/
  }

  delete(classificacao) {
    let classificacoes = this.classificacoes;
    let mercadoriasClassificacaoService = this.mercadoriasClassificacaoService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarIndiceClassificacao')+classificacao.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(classificacoes);
        }

        let index = classificacoes.indexOf(classificacao);
        classificacoes.splice(index, 1);

        mercadoriasClassificacaoService.apagar(classificacao.id)
          .subscribe(res => {
              self.classificacoes = classificacoes;
            },
            err => {
              // Revert the view back to its original state
              classificacoes.splice(index, 0, classificacao);
              self.classificacoes = classificacoes;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.mercadoriasClassificacaoService.getPaginacao(pagina,this.itensPorPagina, ["mercadoria", "defeito"], null, null, {"id_mercadoria": "A", "id_defeito": "A", "ordem": "A"})
      .subscribe(data => {
        this.classificacoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias-classificacao/mercadorias-classificacao.component.ts